export default function DocsText(){
  return(
    <div>
      Document Main Text coming soon! 
    </div>
  );
}